import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Form } from 'foundations-components/transitional/components/Form';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { Link } from 'foundations-components/transitional/components/Link';
import { useState } from 'react';
import { View } from 'foundations-components/components/View';
import { useSubscription } from '../../../hooks/useSubscription';
import { TEST_IDS, URLS } from '../../../utils/constants';
import { handleError } from '../../../utils/errorHandling';
import { useTracker } from '../../../utils/usageTracker';
import { usePauseSubscription } from './usePauseSubscription';
import { useNotificationsQuery } from '../hooks/useNotificationsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function PauseSubscriptionModal({
  objectId,
  actions
}) {
  var _buyer$email;
  const {
    close
  } = actions;
  const {
    trackInteraction
  } = useTracker();
  const {
    buyer,
    checkoutEmail
  } = useSubscription();
  const customerEmail = (_buyer$email = buyer === null || buyer === void 0 ? void 0 : buyer.email) !== null && _buyer$email !== void 0 ? _buyer$email : checkoutEmail;
  const [internalNotes, setInternalNotes] = useState('');
  const [onSubmit, {
    loading: submitLoading
  }] = usePauseSubscription({
    objectId,
    internalNotes,
    onClose: () => {
      close();
      actions.revalidate().catch(handleError);
    }
  });
  const {
    sendEmailForSubscriptionPaused
  } = useNotificationsQuery();
  const getDescriptionMessage = () => {
    if (sendEmailForSubscriptionPaused) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "subscriptions.PauseSubscriptionModal.description_jsx",
        options: {
          email: customerEmail,
          href: URLS.KBPause,
          external: true
        },
        elements: {
          Link
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "subscriptions.PauseSubscriptionModal.descriptionNoNotify"
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    "data-test-id": TEST_IDS.Pause,
    children: /*#__PURE__*/_jsxs(Form, {
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          paddingBlock: "400",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.title"
          })
        }), /*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: () => {
            trackInteraction('pauseSubscriptionModalClosed');
            close();
          }
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "subscriptions.PauseSubscriptionModal.description"
        }), /*#__PURE__*/_jsx(View, {
          marginBlock: "300",
          as: "div",
          children: getDescriptionMessage()
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(FormLabel, {
            marginBlockEnd: "200",
            children: [/*#__PURE__*/_jsx(View, {
              display: "inline-block",
              marginInlineEnd: "100",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "subscriptions.PauseSubscriptionModal.internalNotes.label"
              })
            }), /*#__PURE__*/_jsx(HelpIcon, {
              title: /*#__PURE__*/_jsxs(_Fragment, {
                children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
                  message: "subscriptions.PauseSubscriptionModal.internalNotes.tooltip"
                }), /*#__PURE__*/_jsx(FormattedJSXMessage, {
                  message: "subscriptions.PauseSubscriptionModal.internalNotes.tooltip_jsx",
                  options: {
                    href: URLS.KBPauseTooltip,
                    external: true
                  },
                  elements: {
                    Link
                  }
                })]
              }),
              tooltipPlacement: "right"
            })]
          }), /*#__PURE__*/_jsx(TextArea, {
            rows: 4,
            placeholder: I18n.text('subscriptions.PauseSubscriptionModal.internalNotes.placeholder'),
            resize: false,
            onChange: ({
              currentTarget: {
                value
              }
            }) => {
              setInternalNotes(value);
            }
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(LoadingButton, {
          "data-test-id": `${TEST_IDS.Pause}:submit`,
          use: "primary",
          loading: submitLoading,
          onClick: () => {
            onSubmit().catch(e => handleError(e));
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.pauseButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": `${TEST_IDS.Pause}:cancel`,
          use: "secondary",
          onClick: () => {
            trackInteraction('pauseSubscriptionModalClosed');
            close();
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "subscriptions.PauseSubscriptionModal.cancelButton"
          })
        })]
      })]
    })
  });
}